module.exports = __webpack_public_path__ + "sunsemweb/img/c3.05a1f0d9.png";